import {
  List,
  Datagrid,
  TextField,
  // ChipField,
  NumberField,
  FunctionField,
  // DateField,
  // UrlField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  Create,
  Show,
  SimpleShowLayout,
  NumberInput,
  TextInput,
  // SelectInput,
  // DateTimeInput,
  required,
  // ImageInput,
  useDataProvider,
} from 'react-admin'
import { useState } from 'react'
import { IconButton, Box } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'

import {
  REFERRAL_CLIENT_PREFIX,
  appUrl,
  backendUrl,
} from '../config/constants'

const DownloadReferralsButton = ({ record }) => {
  const [loading, setLoading] = useState(false)
  const dataProvider = useDataProvider()

  const handleDownload = async (e) => {
    e.stopPropagation()
    if (!record || !record.id || !record.clientApiKey) {
      return
    }

    setLoading(true)
    try {
      const { data } = await dataProvider.getReferralClientUsers({
        clientId: record.id,
        apiKey: record.clientApiKey,
      })

      const date = new Date().toISOString().split('T')[0]
      const filename = `${record.title}_${date}.json`
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
      const url_blob = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url_blob
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url_blob)
    } catch (error) {
      console.error('Error downloading referrals:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton onClick={handleDownload} disabled={loading} size="small" color="primary">
        <DownloadIcon />
      </IconButton>
      <span>Referrals</span>
    </Box>
  )
}

export const ReferralClientList = () => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <TextField source="title" />
      <NumberField source="registrations" />
      <NumberField source="clientPercentage" />
      <NumberField source="inviterBonusPercentage" />
      <NumberField source="inviteeBonusPercentage" />
      <FunctionField
        label="Actions"
        render={(record) => <DownloadReferralsButton record={record} />}
      />
      <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
    </Datagrid>
  </List>
)

export const ReferralClientEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" />
      <NumberInput source="clientPercentage" />
      <NumberInput source="inviterBonusPercentage" />
      <NumberInput source="inviteeBonusPercentage" />
      <TextInput source="inviteMessage" fullWidth multiline rows={2} />
      <NumberInput source="registrations" disabled />
      <NumberInput source="clientBonusPoints" disabled />
      <FunctionField
        source="url"
        render={(r) => {
          return `${appUrl}?inviteCode=${REFERRAL_CLIENT_PREFIX}${r.title}`
        }}
      />
    </SimpleForm>
  </Edit>
)

export const ReferralClientCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" validate={[required()]} />
      <NumberInput source="clientPercentage" validate={[required()]} />
      <NumberInput source="inviterBonusPercentage" validate={[required()]} />
      <NumberInput source="inviteeBonusPercentage" validate={[required()]} />
      <TextInput source="inviteMessage" fullWidth multiline rows={2} />
    </SimpleForm>
  </Create>
)

export const ReferralClientShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="id" label="client Id" />
      <TextField source="createdBy" />
      <TextField source="updatedBy" />
      <NumberField source="clientPercentage" />
      <NumberField source="inviterBonusPercentage" />
      <NumberField source="inviteeBonusPercentage" />
      <TextField source="inviteMessage" />
      <NumberField source="registrations" />
      <NumberField source="clientBonusPoints" />
      <FunctionField
        source="url"
        label="Invite URL"
        render={(r) => {
          return `${appUrl}?inviteCode=${REFERRAL_CLIENT_PREFIX}${r.title}`
        }}
      />
      <FunctionField
        source="url"
        label="Check Referral Client User URL"
        render={(r) => {
          return `${backendUrl}/checkReferralClientUser?clientId=${r.id}&apiKey=${r.clientApiKey}`
        }}
      />
    </SimpleShowLayout>
  </Show>
)
